import { useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import UpdateInvoiceToCustomerMutation from '@/graphql/contracts/updateInvoiceToCustomer.mutation.gql';
import GetContractDetailsQuery from '@/graphql/contracts/getContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { UpdateInvoiceToCustomer, UpdateInvoiceToCustomerVariables } from
  '@/graphql/contracts/_generated_/updateInvoiceToCustomer.mutation';
import { UpdateInvoiceToCustomerInputType } from '@/graphql/contracts/_generated_/contracts';
import { ALL_ITEMS } from '@/config/common.config';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';

export default function useUpdateInvoiceToCustomer() {
  const { contractId }: { contractId: string } = useParams();

  const [_updateInvoiceToCustomer, { loading, error, called }] =
    useMutation<UpdateInvoiceToCustomer, UpdateInvoiceToCustomerVariables>(
      UpdateInvoiceToCustomerMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetContractDetailsQuery,
            variables: {
              contractId,
            }
          },
          {
            query: GetBCContractLinesQuery,
            variables: {
              filter: {
                contractId: { eq: contractId }
              },
              first: ALL_ITEMS
            }
          },
          {
            query: GetPaginatedFilteredVariableContractLinesQuery,
            variables: {
              filter: { headerPrimaryKey: { eq: contractId } },
              first: ALL_ITEMS,
            }
          }
        ],
      }
    );
  const updateInvoiceToCustomer = async (input: UpdateInvoiceToCustomerInputType) => {
    await _updateInvoiceToCustomer({
      variables: { input }
    });
  };

  return {
    updateInvoiceToCustomer,
    isLoadingUpdateInvoiceToCustomer: loading,
    errorUpdateInvoiceToCustomer: error,
    isUpdateInvoiceToCustomerWasCalled: called
  } as const;
}
